import { useMutation, useQueryClient } from 'react-query';
import { trpc } from '../../../../lib/trpc';
import { getPropertyTemplatesKeys } from '../../../property-templates/hooks/propertyTemplateQueries';

const useDeletePropertyTemplate = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async (propertyId: number) => {
            return trpc.TemplatesApi.deleteProperty.query({ propertyId });
        },
        {
            onSettled: () => {
                queryClient.invalidateQueries(getPropertyTemplatesKeys.lists());
            },
        },
    );
};

export default useDeletePropertyTemplate;
